/* eslint-disable import/order */
import config from '../../config'
import {
  AUTHENTICATE,
  AUTHENTICATED_USER,
  CHECK_AUTH,
  DICTIONARY_LOADED,
  LOGOUT,
} from './AuthActions'

export const userKey = `${config.storagePrefix}_user`
export const tokenKey = `${config.storagePrefix}_token`
export const permissionsKey = `${config.storagePrefix}_permissions`
export const permissionUserKey = `${config.storagePrefix}_permissionUser`
export const roleKey = `${config.storagePrefix}_role`
export const activeAiAssistantKey = `${config.storagePrefix}_activeAiAssistant`

function returnTheme() {
  // const date = new Date()

  // if (date.getHours() <= 8 || date.getHours() >= 18) {
  //   return 'themeDark'
  // }
  return 'theme'
}

const INITIAL_STATE = {
  forgotPassword: false,
  loading: false,
  modal: false,
  user: null,
  token: '',
  laundryConfigs: [],
  // País, idioma, fuso e moeda do tenant (só leitura, vem do /user/init)
  tenantLocale: null,
  // Rótulos no idioma do tenant (chave => rótulo, vem do /dictionary)
  dictionary: null,
  permissions: [],
  permissionUser: [],
  role: [],
  activeAiAssistant: false,
  theme: returnTheme(),
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AUTHENTICATE.ACTION:
      return { ...state, loading: true }
    case AUTHENTICATE.SUCCESS:
      localStorage.setItem(tokenKey, JSON.stringify(action.payload))
      return { ...state, token: action.payload, loading: false }
    case AUTHENTICATE.FAILURE:
      return { ...state, loading: false }
    case AUTHENTICATED_USER.SUCCESS:
      localStorage.setItem(userKey, JSON.stringify(action.payload.data.item))
      localStorage.setItem(
        permissionsKey,
        JSON.stringify(action.payload.data.permissions)
      )
      localStorage.setItem(
        permissionUserKey,
        JSON.stringify(action.payload.data.permission_user)
      )
      localStorage.setItem(
        roleKey,
        JSON.stringify(action.payload.data.userRole)
      )
      localStorage.setItem(
        activeAiAssistantKey,
        JSON.stringify(!!action.payload.data.active_ai_assitant)
      )
      return {
        ...state,
        user: action.payload.data.item,
        permissions: action.payload.data.permissions,
        permissionUser: action.payload.data.permission_user,
        laundryConfigs: action.payload.data.laundry_configs,
        tenantLocale: action.payload.data.country
          ? {
              country: action.payload.data.country,
              locale: action.payload.data.locale,
              timezone: action.payload.data.timezone,
              currency: action.payload.data.currency,
            }
          : null,
        role: action.payload.data.userRole,
        activeAiAssistant: !!action.payload.data.active_ai_assitant,
        loading: false,
      }
    case DICTIONARY_LOADED:
      return { ...state, dictionary: action.payload }
    case CHECK_AUTH:
      if (typeof localStorage !== 'undefined') {
        const newState = { ...state }
        const user = localStorage.getItem(userKey)
        const permissions = localStorage.getItem(permissionsKey)
        const permissionUser = localStorage.getItem(permissionUserKey)
        const role = localStorage.getItem(roleKey)
        const activeAiAssistant = localStorage.getItem(activeAiAssistantKey)

        if (user) {
          newState.user = JSON.parse(user)
          newState.permissions = JSON.parse(permissions)
          newState.permissionUser = permissionUser ? JSON.parse(permissionUser) : []
          newState.role = JSON.parse(role)
          newState.activeAiAssistant = activeAiAssistant
            ? JSON.parse(activeAiAssistant)
            : false
        }
        const token = localStorage.getItem(tokenKey)
        if (token) {
          newState.token = JSON.parse(token)
        }
        return newState
      }

      return { ...state }
    case LOGOUT.SUCCESS:
      localStorage.removeItem(userKey)
      localStorage.removeItem(tokenKey)
      localStorage.removeItem(permissionsKey)
      localStorage.removeItem(permissionUserKey)
      localStorage.removeItem(roleKey)
      localStorage.removeItem(activeAiAssistantKey)
      return {
        ...state,
        user: null,
        token: null,
        tenantLocale: null,
        dictionary: null,
        // Sem isso o próximo login renderiza com os papéis do usuário anterior
        // até o /user/init voltar (ex.: gerente chamando /alerts do admin)
        permissions: [],
        permissionUser: [],
        role: [],
        laundryConfigs: [],
        activeAiAssistant: false,
      }
    case LOGOUT.FAILURE:
      localStorage.removeItem(userKey)
      localStorage.removeItem(tokenKey)
      localStorage.removeItem(permissionsKey)
      localStorage.removeItem(permissionUserKey)
      localStorage.removeItem(roleKey)
      localStorage.removeItem(activeAiAssistantKey)
      return {
        ...state,
        user: null,
        token: null,
        tenantLocale: null,
        dictionary: null,
        // Sem isso o próximo login renderiza com os papéis do usuário anterior
        // até o /user/init voltar (ex.: gerente chamando /alerts do admin)
        permissions: [],
        permissionUser: [],
        role: [],
        laundryConfigs: [],
        activeAiAssistant: false,
      }
    default:
      return state
  }
}
